import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-truck-moving p-mr-2" }, null, -1)
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AutoComplete, _mergeProps({
      modelValue: _ctx.searchBox,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
      minLength: 2,
      suggestions: _ctx.suggestions,
      completeOnFocus: "",
      dropdown: "",
      field: "business_name",
      placeholder: "Cerca fornitore"
    }, _ctx.$attrs, {
      onChange: _ctx.onChange,
      onComplete: _ctx.search,
      onItemSelect: _ctx.onSelect
    }), {
      item: _withCtx(({item}) => [
        _hoisted_1,
        _createElementVNode("strong", null, _toDisplayString(item.business_name), 1),
        (item.name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " - " + _toDisplayString(item.name), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["modelValue", "suggestions", "onChange", "onComplete", "onItemSelect"]),
    (_ctx.searchBox)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "clear-times",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
        }, " × "))
      : _createCommentVNode("", true)
  ], 64))
}